<div class="motors-listing-details-page">
  <tg-row>
    <tg-col md="8">
      <h1 class="motors-listing-details-page__title">
        How would you like to sell your boat?
      </h1>
    </tg-col>
    <tg-col md="4">
      <motors-cannot-edit-something-message-section [isListingDetails]="true">
      </motors-cannot-edit-something-message-section>
    </tg-col>
  </tg-row>

  <tg-row *ngIf="!isHideMotorsListingDetailsHeaderSectionComponent">
    <tg-col class="motors-listing-details-page__section--padding-bottom">
      <motors-listing-details-header-section></motors-listing-details-header-section>
    </tg-col>
  </tg-row>

  <tg-row>
    <tg-col class="motors-listing-details-page__section--padding-bottom">
      <tg-row
        *ngIf="
          draftState.draftData.listingDetails.sellingType ===
          SellingTypeEnum.classified
        "
      >
        <tg-col class="motors-listing-details-page__section--padding-top">
          <h2>Your classified details</h2>
          <motors-classified-pricing-section></motors-classified-pricing-section>
          <motors-ending-datetime-section></motors-ending-datetime-section>
        </tg-col>
      </tg-row>

      <tg-row
        *ngIf="
          draftState.draftData.listingDetails.sellingType ===
          SellingTypeEnum.auction
        "
      >
        <tg-col class="motors-listing-details-page__section--padding-top">
          <h2>Your auction details</h2>
          <motors-auction-pricing-section></motors-auction-pricing-section>
          <motors-ending-datetime-section></motors-ending-datetime-section>
          <motors-vehicle-transfer-options-section></motors-vehicle-transfer-options-section>
          <motors-accepted-payments-section></motors-accepted-payments-section>
        </tg-col>
      </tg-row>
    </tg-col>
  </tg-row>

  <tg-row>
    <tg-col class="motors-listing-details-page__section--padding-bottom">
      <motors-listing-details-contact-section></motors-listing-details-contact-section>
    </tg-col>
  </tg-row>
  <tg-row>
    <tg-col class="motors-listing-details-page__section--padding-bottom">
      <motors-listing-details-package-section></motors-listing-details-package-section>
    </tg-col>
  </tg-row>
</div>
